import { render, staticRenderFns } from "./listDedicatedDiet.vue?vue&type=template&id=81856eaa&scoped=true"
import script from "./listDedicatedDiet.vue?vue&type=script&lang=js"
export * from "./listDedicatedDiet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81856eaa",
  null
  
)

export default component.exports